export enum EventName {
  Esia = 'esia_registration_start',
  InnFound = 'inn_found_and_placed',
  InnNotFound = 'inn_not_found',
  PhoneChanged = 'phone_changed',
  PhoneLinked = 'phone_linked',
  CardType = 'card_number_type',
  CardLinked = 'card_linked',
  Registration = 'registration_step',
  MobileID = 'personal_data_set',
  FrontendLkApiRestRequests = 'frontend_lk_api_rest_requests',
  CancelingBareBasket = 'canceling_bare_basket',
  ForwardToLK = 'forward_to_lk',
  IncomeModalWindowClosed = 'income_modal_window_closed',
}
